import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import Splitting from "splitting";

/* ==============================================
ヘッダーの部分
============================================== */
export function servicesFunc() {
  let servicesTop = $("#servicesTop").length;

  if (servicesTop) {
    // subNavHeightFunc();

    subNavAccordionFuc();
    subNavScrollFunc();

    // function subNavHeightFunc() {
    //   let subNavHeight = $(".subNav");
    //   let headerHeight = $("#header").outerHeight();
    //   subNavHeight.css("top", `${headerHeight}px`);

    //   let setTimer = false;
    //   $(window).on("resize", function () {
    //     if (setTimer !== false) {
    //       clearTimeout(setTimer);
    //     }
    //     setTimer = setTimeout(() => {
    //       subNavHeightFunc();
    //     }, 200);
    //   });
    // }

    function subNavAccordionFuc() {
      const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
      const servicesSubNav = $("#servicesSubNavList a");
      let resizecheck = $("#responsibleCheck").width();
      let resizecheck2 = 0;

      $(window).on("load resize", function () {
        resizecheck = $("#responsibleCheck").width();
        subNavAccordionMenuStart();
        subNavCloseFunc();
      });

      //スマホのみサブナビをクリックでクローズさせる
      function subNavCloseFunc() {
        if (resizecheck == "2") {
          servicesSubNav.on("click", subNavClickHandler);
        } else if (resizecheck == "1") {
          servicesSubNav.off("click", subNavClickHandler);
        }
      }
      function subNavClickHandler() {
        servicesSubNavAccordionBtn.next("dd").slideUp(500);
        $("#servicesSubNav").removeClass("isNavOpen");
        servicesSubNavAccordionBtn.removeClass("isOpen");
      }
      subNavCloseFunc();

      servicesSubNavAccordionBtn.on("click", function () {
        const subNav = $("#servicesSubNav");

        if (resizecheck == "2") {
          if ($(this).hasClass("isOpen")) {
            $(this)
              .next("dd")
              .slideUp(500, function () {
                subNav.removeClass("isNavOpen");
              });
            $(this).removeClass("isOpen");
          } else {
            servicesSubNavAccordionBtn.next("dd").slideUp(500);
            servicesSubNavAccordionBtn.removeClass("isOpen");
            $(this).next("dd").slideDown(500);
            $(this).addClass("isOpen");

            subNav.addClass("isNavOpen");
          }
        }
      });

      var subNavAccordionMenuStart = function () {
        let resizecheck = $("#responsibleCheck").width();
        if (resizecheck == "2" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.next("dd").css("display", "none");
          resizecheck2 = 2;
        } else if (resizecheck == "1" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.removeClass("isOpen");
          servicesSubNavAccordionBtn.next("dd").css("display", "block");
          resizecheck2 = 1;
        }
      };
      subNavAccordionMenuStart();
    }

    function subNavScrollFunc() {
      // 今回の交差を監視する要素
      const boxes = document.querySelectorAll(".servicesList .list");

      const options = {
        root: null,
        rootMargin: "0% 0px -87%",
        threshold: 0,
      };
      const observer = new IntersectionObserver(doWhenIntersect, options);
      boxes.forEach((box) => {
        observer.observe(box);
      });

      /**
       * 交差したときに呼び出す関数
       * @param entries
       */
      function doWhenIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activateIndex(entry.target);
          }
        });
      }
      /**
       * 目次を変える関数
       * @param element
       */
      function activateIndex(element) {
        const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
        if (currentActiveIndex !== null) {
          currentActiveIndex.classList.remove("active");
        }
        const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
        newActiveIndex.classList.add("active");

        const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
        $("#navCurrent").text(currentTxt).css({ color: "#fff" });
      }
    }

    $(window).on("load scroll", function () {
      var subNavCurrent = $("#servicesSubNavList .pageLinkList");
      var scroll = $(window).scrollTop();
      if (scroll == 0) {
        $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
        if (subNavCurrent.hasClass("active")) {
          subNavCurrent.removeClass("active");
        }
      }
    });
  }
}

export function animation() {
  // 商品ホバー時（PC）
  $(function () {
    $(".productItemOther").each(function (index) {
      $(this).on("mouseenter", function () {
        // 全キャラを一旦リセット
        $(".productCharaItem").css("opacity", "1");

        // キャラ 0.7
        $(".productCharaItem").eq(index).css("opacity", ".7");

        // 商品 0.7
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", ".7");
      });

      $(this).on("mouseleave", function () {
        // 全てを元に戻す
        $(".productCharaItem").css("opacity", "1");
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", "1");
      });
    });
  });
  // 商品ホバー時（SP）

  /* =============================================
gsap
============================================= */
  // ==============================================
  // Grid Reveal Setup
  // ==============================================

  function setupGridReveal(target) {
    const rows = Number(target.dataset.rows) || 15;
    const cols = Number(target.dataset.cols) || 25;

    target.style.gridTemplateRows = `repeat(${rows}, 1fr)`;
    target.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;

    if (target.querySelector(".panel")) return;

    for (let i = 0; i < rows * cols; i++) {
      const panel = document.createElement("div");
      panel.classList.add("panel");
      target.appendChild(panel);
    }
  }

  // ==============================================
  // Grid Reveal Animation
  // ==============================================

  // function createGridReveal(target) {
  //   const speed = Number(target.dataset.speed) || 5;

  //   const panels = Array.from(target.querySelectorAll(".panel"));

  //   function shuffle(array) {
  //     for (let i = array.length - 1; i > 0; i--) {
  //       const j = Math.floor(Math.random() * (i + 1));

  //       const temp = array[i];
  //       array[i] = array[j];
  //       array[j] = temp;
  //     }

  //     return array;
  //   }

  //   const shuffledPanels = shuffle(panels);

  //   return new Promise((resolve) => {
  //     shuffledPanels.forEach((panel, index) => {
  //       setTimeout(() => {
  //         panel.classList.add("fade-out");

  //         if (index === shuffledPanels.length - 1) {
  //           setTimeout(() => {
  //             target.remove();
  //             resolve();
  //           }, 10000);
  //         }
  //       }, index * speed);
  //     });
  //   });
  // }
  function createGridReveal(target) {
    const speed = Number(target.dataset.speed) || 5;
    const batch = Number(target.dataset.batch) || 1;

    const panels = Array.from(target.querySelectorAll(".panel"));

    for (let i = panels.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [panels[i], panels[j]] = [panels[j], panels[i]];
    }

    return new Promise((resolve) => {
      let index = 0;

      const timer = setInterval(() => {
        for (let i = 0; i < batch && index < panels.length; i++) {
          panels[index].classList.add("fade-out");
          index++;
        }

        if (index >= panels.length) {
          clearInterval(timer);
          target.remove();
          resolve();
        }
      }, speed);
    });
  } // ==============================================
  // 初期化
  // ==============================================

  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    // 全ての grid-overlay に黒マスを生成
    document.querySelectorAll("[data-grid-reveal]").forEach((overlay) => {
      setupGridReveal(overlay);
    });

    // productChara
    const productOverlay = document.querySelector(".productChara [data-grid-reveal]");

    if (productOverlay) {
      ScrollTrigger.create({
        trigger: ".productChara",
        start: isSP ? "top 70%" : "top 70%",
        once: true,
        // markers: true,

        ...(isSP && {
          scroller: ".drawerScroll",
        }),

        onEnter: () => {
          createGridReveal(productOverlay);
        },
      });
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    // 全ての grid-overlay に黒マスを生成
    document.querySelectorAll("[data-grid-reveal]").forEach((overlay) => {
      setupGridReveal(overlay);
    });

    // productChara
    const productOverlay = document.querySelector(".specialImg [data-grid-reveal]");

    if (productOverlay) {
      ScrollTrigger.create({
        trigger: ".specialImg",
        start: isSP ? "top 70%" : "top 70%",
        once: true,
        // markers: true,

        ...(isSP && {
          scroller: ".drawerScroll",
        }),

        onEnter: () => {
          createGridReveal(productOverlay);
        },
      });
    }
  });

  // ==============================================
  // FV
  // ==============================================

  function initFV() {
    const isSP = window.innerWidth <= 768;

    const overlay = isSP ? document.querySelector(".fvBgSp [data-grid-reveal]") : document.querySelector(".fvBg [data-grid-reveal]");

    if (!overlay) return;

    // パネルがなければ再生成
    setupGridReveal(overlay);

    const tl = gsap.timeline({ paused: true });

    if (isSP) {
      gsap.set(".fvLogo1Sp, .fvLogo2Sp,.fvTxtSp, .fvCopyrightSp", {
        autoAlpha: 0,
      });

      tl.to(".fvLogo1Sp, .fvLogo2Sp,.fvTxtSp, .fvCopyrightSp", {
        autoAlpha: 1,
        duration: 1,
        ease: "power1.inOut",
      });
    } else {
      gsap.set(".fvLogo1, .fvLogo2,.fvTxt,.fvCopyright", {
        autoAlpha: 0,
      });

      tl.to(".fvLogo1, .fvLogo2,.fvTxt,.fvCopyright", {
        autoAlpha: 1,
        duration: 1,
        ease: "power1.inOut",
      });
    }

    gsap.delayedCall(1, () => {
      createGridReveal(overlay).then(() => {
        tl.play();
      });
    });
  }

  // 初回
  window.addEventListener("DOMContentLoaded", initFV);

  // ブレークポイント跨ぎのみ再実行
  let wasSP = window.innerWidth <= 768;

  window.addEventListener("resize", () => {
    const isSP = window.innerWidth <= 768;

    if (isSP !== wasSP) {
      wasSP = isSP;
      initFV();
    }
  });
  //各セクションごとのフェードイン
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.utils.toArray(".fadeIn").forEach((target) => {
      gsap.fromTo(
        target,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          scrollTrigger: {
            trigger: target,
            start: "top 70%",

            ...(isSP && {
              scroller: ".drawerScroll",
            }),
          },
        },
      );
    });
  });

  //Introのフェードイン
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.utils.toArray(".IntroFadeIn").forEach((target) => {
      gsap.fromTo(
        target,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          scrollTrigger: {
            trigger: target,
            start: "top 75%",

            ...(isSP && {
              scroller: ".drawerScroll",
            }),
          },
        },
      );
    });
  });

  //各セクションごとの左からフェードイン
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.utils.toArray(".fadeInLeft").forEach((target) => {
      gsap.fromTo(
        target,
        {
          autoAlpha: 0,
          x: -100,
        },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: target,
            start: "top 70%",

            ...(isSP && {
              scroller: ".drawerScroll",
            }),
          },
        },
      );
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const drawerIcon = document.querySelector(".drawerIcon");
  const drawer = document.querySelector(".drawer");
  const drawerNavItem = document.querySelectorAll('.drawer a[href^="#"]');

  const breakpoint = 768;

  // アニメーション中判定
  let isAnimating = false;
  let closeTimer = null;

  // 開く
  const openMenu = () => {
    if (isAnimating) return;

    isAnimating = true;
    clearTimeout(closeTimer);

    drawer.classList.remove("is-closing");

    drawer.classList.add("js-show");
    drawerIcon.classList.add("js-show");

    document.body.classList.add("is-lock");

    setTimeout(() => {
      isAnimating = false;
    }, 500);
  };

  // 閉じる
  const closeMenu = () => {
    if (isAnimating) return;

    isAnimating = true;

    drawer.classList.add("is-closing");
    drawerIcon.classList.remove("js-show");

    setTimeout(() => {
      drawer.classList.remove("js-show");
      drawer.classList.remove("is-closing");

      document.body.classList.remove("is-lock");

      isAnimating = false;
    }, 500);
  };

  // 開閉
  const toggleMenu = () => {
    if (isAnimating) return;

    if (drawer.classList.contains("js-show")) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // リサイズ
  const handleResize = () => {
    if (window.innerWidth > breakpoint) {
      closeMenu();
    }
  };

  // 外クリック
  const clickOuter = (event) => {
    if (drawer.classList.contains("js-show") && !drawer.contains(event.target) && !drawerIcon.contains(event.target)) {
      closeMenu();
    }
  };

  // ハンバーガー
  drawerIcon.addEventListener("click", toggleMenu);

  // リサイズ
  window.addEventListener("resize", handleResize);

  // 外クリック
  document.addEventListener("click", clickOuter);

  // 新・スクロール関数（.drawerScrollの中を動かす仕様）
  const linkScroll = (target) => {
    if (!target) return;

    // スクロールさせる全体の器（.drawerScroll）を取得
    const scrollContainer = document.querySelector(".drawerScroll") || window;

    if (scrollContainer === window) {
      // 万が一コンテナがない場合のフォールバック
      const targetPosition = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    } else {
      // .drawerScroll の中をスクロールさせる
      const containerTop = scrollContainer.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top;
      // 現在のスクロール位置 + ターゲットの相対位置
      const scrollTarget = scrollContainer.scrollTop + (targetTop - containerTop);

      scrollContainer.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    }
  };

  // 新・ページ内リンクのクリックイベント
  drawerNavItem.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      const targetItem = document.querySelector(item.getAttribute("href"));

      // 1. まずドロワーを閉じる（アニメーション開始。ここでbodyのlock解除などが予約されます）
      closeMenu();

      // 2. ドロワーが閉じるアニメーション（500ms）が終わるのを待ってからスクロール
      setTimeout(() => {
        linkScroll(targetItem);
      }, 50);
    });
  });
});

/* =============================================
商品のスライダー
============================================= */
// // 初期化・破壊を切り替える関数
// let swiperInstance = null;

// function toggleSwiper1() {
//   const isSP1 = window.matchMedia("(max-width: 767px)").matches;
//   const swiperEl1 = document.querySelector(".product__swiper");

//   if (isSP1) {
//     // SPサイズならSwiperを初期化
//     if (!swiperInstance) {
//       swiperInstance = new Swiper(swiperEl1, {
//         speed: 1000,
//         effect: "slide",
//         allowTouchMove: true,
//         loop: true,
//         autoplay: {
//           delay: 3000,
//           disableOnInteraction: false,
//         },

//         centeredSlides: true,
//         slidesPerView: 1,
//         spaceBetween: 0,
//         // spaceBetween: window.innerWidth * 0.094,

//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//           type: "bullets",
//         },
//         navigation: {
//           prevEl: ".swiper-button-prev",
//           nextEl: ".swiper-button-next",
//         },
//       });
//     }
//   } else {
//     // PCサイズならSwiperを破棄
//     if (swiperInstance) {
//       swiperInstance.destroy(true, true);
//       swiperInstance = null;

//       // SP用に付与されたクラスやスタイルを完全リセット
//       swiperEl1.classList.remove("swiper-initialized", "swiper-horizontal", "swiper-backface-hidden", "swiper-free-mode", "swiper-wp8-horizontal");
//       swiperEl1.querySelectorAll(".swiper-slide").forEach((slide) => {
//         slide.style.width = "";
//         slide.style.marginRight = "";
//       });

//       // 必要ならpaginationやnavigationもリセット
//       const pag = swiperEl1.querySelector(".swiper-pagination");
//       if (pag) pag.innerHTML = "";
//     }
//   }
//   const productSwiper = new Swiper(".productWrap", {
//     // ここは既存の設定に合わせて OK
//     on: {
//       slideChange: function () {
//         // 一旦全部非表示
//         const charas = document.querySelectorAll(".product__swiper-slide-chara");
//         charas.forEach((c) => (c.style.opacity = 0));

//         // active index に対応するキャラだけ表示
//         const activeIndex = this.activeIndex;
//         const activeChara = document.querySelector(`.product__swiper-slide-chara:nth-of-type(${activeIndex + 1})`);
//         if (activeChara) activeChara.style.opacity = 1;
//       },
//     },
//   });
// }

// // 初回実行
// toggleSwiper1();
// // リサイズ時も切り替え
// window.addEventListener("resize", toggleSwiper1);

//1文字ずつフェードイン
window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const fadeInText = document.querySelectorAll(".animated__fadeIn");

  fadeInText.forEach((item) => {
    Splitting({
      target: item,
      by: "chars",
    });

    const chars = item.querySelectorAll(".char");

    gsap.set(chars, {
      autoAlpha: 0,
    });

    ScrollTrigger.create({
      trigger: item,
      start: "top 70%",
      // markers: true,

      ...(isSP && {
        scroller: ".drawerScroll",
      }),

      onEnter: () => {
        gsap.to(chars, {
          autoAlpha: 1,
          stagger: 0.005,
          duration: 0.02,
          ease: "power2.out",
        });
      },
    });
  });
});

window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const wrap = document.querySelector(".productTtlWrap");

  const bg = wrap.querySelector(".productTtlBg");
  const en = wrap.querySelector(".productTtlEn");
  const ja = wrap.querySelector(".productTtlJa");

  // ① 初期状態
  gsap.set(bg, { autoAlpha: 0 });
  gsap.set(en, { autoAlpha: 0, x: -10 });
  gsap.set(ja, { autoAlpha: 0, x: -10 });

  ScrollTrigger.create({
    trigger: wrap,
    start: "top 70%",
    // markers: true,

    ...(isSP && {
      scroller: ".drawerScroll",
    }),

    onEnter: () => {
      // ① 背景
      gsap.to(bg, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      });

      // ② 英語タイトル（軽くスライド）
      gsap.to(en, {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        delay: 0.2,
        ease: "power2.out",
      });

      // ③ 日本語（左→右で1文字ずつ）
      gsap.to(ja, {
        autoAlpha: 1,
        x: 0,
        stagger: 0.03,
        duration: 0.4,
        delay: 0.4,
        ease: "power2.out",
      });
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".specialTtlWrap",
      start: "top 70%",

      ...(isSP && {
        scroller: ".drawerScroll",
      }),

      once: true,
    },
  });

  tl.from(".specialTtlDeco.Left", {
    x: -200,
    autoAlpha: 0,
    duration: 0.5,
    ease: "power2.out",
  })
    .from(
      ".specialTtlDeco.Right",
      {
        x: 200,
        autoAlpha: 0,
        duration: 0.5,
        ease: "power2.out",
      },
      "<", // Leftと同時
    )
    .from(".specialTtl", {
      autoAlpha: 0,
      duration: 0.5,
      ease: "power2.out",
    });
});

window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  document.querySelectorAll(".specWrapInfoBody").forEach((item) => {
    const mask = item.querySelector(".specWrapInfoMask");
    const ttl = item.querySelector(".specInfoTtl");
    const txt = item.querySelector(".specInfoTxt");

    if (!mask || !ttl || !txt) return;

    Splitting({
      target: txt,
      by: "chars",
    });

    const chars = txt.querySelectorAll(".char");

    gsap.set(chars, {
      autoAlpha: 0,
    });

    gsap.set(txt, {
      opacity: 1,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top 70%",
        ...(isSP && {
          scroller: ".drawerScroll",
        }),
        once: true,
      },
    });

    // 左上 → 右下ワイプ
    tl.to(mask, {
      x: "100%",
      y: "100%",
      duration: isSP ? 1.5 : 1.5,
      ease: "none",
    })
      .set(mask, {
        autoAlpha: 0,
      })
      // タイトル
      .to(
        ttl,
        {
          autoAlpha: 1,
          y: 0,
          duration: isSP ? 0.5 : 0.7,
          ease: "power2.out",
        },
        "<-.9",
      )

      // テキスト
      .to(
        chars,
        {
          autoAlpha: 1,
          stagger: isSP ? 0.015 : 0.008,
          duration: 0.03,
          ease: "power2.out",
        },
        "<",
      );
  });
});
window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const wrap = document.querySelector(".radenTtlWrap");

  const bg = wrap.querySelector(".radenTtlBg");
  const hira = wrap.querySelector(".radenTtlHira");
  const ja = wrap.querySelector(".radenTtlJa");

  // ① 初期状態
  gsap.set(bg, { autoAlpha: 0 });
  gsap.set(hira, { autoAlpha: 0, x: -10 });
  gsap.set(ja, { autoAlpha: 0, x: -10 });

  ScrollTrigger.create({
    trigger: wrap,
    start: "top 70%",
    // markers: true,

    ...(isSP && {
      scroller: ".drawerScroll",
    }),

    onEnter: () => {
      gsap.to(bg, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      });

      gsap.to([ja, hira], {
        autoAlpha: 1,
        x: 0,
        stagger: 0.03,
        duration: 0.4,
        delay: 0.4,
        ease: "power2.out",
      });
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const scroll = document.querySelector("#js-images-scroll");
  const images = document.querySelector("#js-images");

  if (!scroll || !images) return;

  // 追加したい複製数
  const cloneCount = 3;

  const clones = [];

  for (let i = 0; i < cloneCount; i++) {
    const clone = images.cloneNode(true);

    clone.removeAttribute("id");

    scroll.appendChild(clone);

    clones.push(clone);
  }

  const setup = () => {
    const items = [...images.children];

    let maxRight = 0;

    items.forEach((item) => {
      const left = parseFloat(getComputedStyle(item).left);
      const width = item.offsetWidth;

      maxRight = Math.max(maxRight, left + width);
    });

    images.style.setProperty("--images-width", `${maxRight}px`);

    clones.forEach((clone) => {
      clone.style.setProperty("--images-width", `${maxRight}px`);
    });

    scroll.style.setProperty("--images-width", `${maxRight}px`);
  };

  setup();

  window.addEventListener("resize", setup);
});

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  gsap.utils.toArray(".fadeInDialHead").forEach((target) => {
    const ttl = target.querySelector(".dialHeadTtl");
    const lineImg = target.querySelector(".dialHeadLine img");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: target,
        start: isSP ? "top 70%" : "top 70%",

        ...(isSP && {
          scroller: ".drawerScroll",
        }),

        once: true,
      },
    });

    // タイトル
    tl.fromTo(
      ttl,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.5,
        ease: "power2.out",
      },
    )

      // ライン
      .fromTo(
        lineImg,
        {
          autoAlpha: 0,
          scaleX: 0,
          transformOrigin: "center center",
        },
        {
          autoAlpha: 1,
          scaleX: 1,
          duration: 1.5,
          ease: "power3.out",
        },
        "<",
      );
  });
});

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  gsap.utils.toArray(".buildHeadWrap").forEach((target) => {
    const ttl = target.querySelector(".buildHeadTtl");
    const lineImg = target.querySelector(".buildHeadLine img");
    const txt = target.querySelector(".buildHeadTxt");

    // 初期状態
    gsap.set(ttl, {
      autoAlpha: 0,
    });

    gsap.set(txt, {
      autoAlpha: 0,
    });

    gsap.set(lineImg, {
      autoAlpha: 0,
      scaleX: 0,
      transformOrigin: "center center",
    });

    ScrollTrigger.create({
      trigger: target,
      start: isSP ? "top 70%" : "top 70%",

      ...(isSP && {
        scroller: ".drawerScroll",
      }),

      once: true,

      onEnter: () => {
        // タイトル
        gsap.to(ttl, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "power2.out",
        });

        // サブテキスト
        gsap.to(txt, {
          autoAlpha: 1,
          duration: 0.5,
          ease: "power2.out",
        });

        // ライン（中央→左右）
        gsap.to(lineImg, {
          autoAlpha: 1,
          scaleX: 1,
          duration: 1.5,
          ease: "power3.out",
        });
      },
    });
  });
});

window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const wrap = document.querySelector(".meisterTtlWrap");

  const bg = wrap.querySelector(".meisterTtlBg");
  const ja = wrap.querySelector(".meisterTtlEn");

  // ① 初期状態
  gsap.set(bg, { autoAlpha: 0 });
  gsap.set(ja, { autoAlpha: 0, x: -10 });

  ScrollTrigger.create({
    trigger: wrap,
    start: "top 70%",
    // markers: true,

    ...(isSP && {
      scroller: ".drawerScroll",
    }),

    onEnter: () => {
      gsap.to(bg, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      });

      gsap.to(ja, {
        autoAlpha: 1,
        x: 0,
        stagger: 0.03,
        duration: 0.4,
        delay: 0.4,
        ease: "power2.out",
      });
    },
  });
});

window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  const wrap = document.querySelector(".shopListTtlWrap");

  const bg = wrap.querySelector(".shopListTtlBg");
  const en = wrap.querySelector(".shopListTtlEn");
  const ja = wrap.querySelector(".shopListTtlJa");

  // ① 初期状態
  gsap.set(bg, { autoAlpha: 0 });
  gsap.set(en, { autoAlpha: 0, x: -10 });
  gsap.set(ja, { autoAlpha: 0, x: -10 });

  ScrollTrigger.create({
    trigger: wrap,
    start: "top 70%",
    // markers: true,

    ...(isSP && {
      scroller: ".drawerScroll",
    }),

    onEnter: () => {
      // ① 背景
      gsap.to(bg, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      });

      // ② 英語タイトル（軽くスライド）
      gsap.to(en, {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        delay: 0.2,
        ease: "power2.out",
      });

      // ③ 日本語（左→右で1文字ずつ）
      gsap.to(ja, {
        autoAlpha: 1,
        x: 0,
        stagger: 0.03,
        duration: 0.4,
        delay: 0.4,
        ease: "power2.out",
      });
    },
  });
});

window.addEventListener("load", function () {
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.innerWidth <= 768;

  gsap.utils.toArray(".js-product-fade").forEach((item) => {
    gsap.set(item, {
      autoAlpha: 0,
    });

    ScrollTrigger.create({
      trigger: item,
      start: "top 70%",

      ...(isSP && {
        scroller: ".drawerScroll",
      }),

      once: true,

      onEnter: () => {
        gsap.to(item, {
          autoAlpha: 1,
          duration: 0.8,
          ease: "power2.out",
        });
      },
    });
  });
});
